import React, { useEffect, useState } from "react";
import "../CSS/Home.css";
import IMG from "../Assets/slider1.jpg";
import IMG2 from "../Assets/slider2.jpg";

import AboutSection from "../Components/AboutSection"
import WhyChoose from "../Components/WhyChoose"
import Services from "../Components/Services"
import Process from "../Components/Process"

const Home = () => {

  const slides = [
    {
      image: IMG,
      alt: "MEA Apostille Attestation Service in India for Certificate Verification",
      title: (
        <>
          MEA Apostille Attestation <br />
          Service in India
        </>
      ),
      highlight: "We are now open!",
      subtext:
        "Fast and reliable MEA Apostille and Certificate Attestation Services available across PAN India for personal, educational and commercial documents."
    },
    {
      image: IMG2,
      alt: "Mumbai's No.1 Certificate Attestation and Apostille Services",
      title: (
        <>
          Mumbai's #1 Certificate <br />
          Attestation Services
        </>
      ),
      highlight: "Trusted & Fast Process",
      subtext:
        "We handle and accept all types of certificates for attestation including educational, personal and commercial documents with quick processing."
    }
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(slider);
  }, []);

  return (
    <div className="home">

      <section className="hero">

        <img
          src={slides[index].image}
          alt={slides[index].alt}
          className="hero-image"
        />

        <div className="overlay"></div>

        <div className="hero-content">

          <h1>{slides[index].title}</h1>

          {slides[index].highlight && (
            <p className="highlight">{slides[index].highlight}</p>
          )}

          <p className="subtext">{slides[index].subtext}</p>

        </div>

      </section>

      <AboutSection/>
      <WhyChoose/>
      <Services/>
      <Process/>

    </div>
  );
};

export default Home;